const RemoveCircled = () => (
  <>
    <path
      fill="currentColor"
      d="M8 12.5h8q.212 0 .356-.144a.49.49 0 0 0 .144-.357.48.48 0 0 0-.144-.356A.48.48 0 0 0 16 11.5H8a.48.48 0 0 0-.356.144.49.49 0 0 0-.144.357q0 .212.144.356A.49.49 0 0 0 8 12.5m4.003 8.5a8.8 8.8 0 0 1-3.51-.709 9.1 9.1 0 0 1-2.859-1.922 9.1 9.1 0 0 1-1.925-2.857A8.75 8.75 0 0 1 3 12.003q0-1.866.708-3.51a9.1 9.1 0 0 1 1.923-2.859 9.1 9.1 0 0 1 2.857-1.925A8.75 8.75 0 0 1 11.997 3q1.866 0 3.51.708a9.1 9.1 0 0 1 2.859 1.923 9.1 9.1 0 0 1 1.925 2.857A8.75 8.75 0 0 1 21 11.997a8.8 8.8 0 0 1-.709 3.51 9.1 9.1 0 0 1-1.922 2.859 9.1 9.1 0 0 1-2.857 1.925 8.75 8.75 0 0 1-3.509.709M12 20q3.35 0 5.675-2.325T20 12t-2.325-5.675T12 4 6.325 6.325 4 12t2.325 5.675T12 20"
    />
  </>
)
export default RemoveCircled
